var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-scroll"},[(_vm.loading || _vm.reload)?_c('ui-overlay-load'):_vm._e(),_c('select-facebook-user',{attrs:{"value":_vm.datatable.data,"total":_vm.datatable.total},on:{"next-handler":function($event){return _vm.nextPageHandler()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }